import orderEditService from 'app/services/OrderEditService'

interface RefundParam {
  id: string
  orderNumber: string
}

export const refundEntirePOSOrder = async (
  order: RefundParam,
  mfOrderReturn: (order: any) => any
) => {
  const posOrderTransaction: any = await orderEditService.getOrderTransactions(order.id)
  const {amount, metaData, paymentReferenceId, paymentType} = posOrderTransaction
  const posOrder = {
    amount,
    paymentReferenceId,
    metaData,
    paymentType,
    orderNumber: order.orderNumber,
    orderId: order.id,
  }

  if (mfOrderReturn) {
    await mfOrderReturn(posOrder)
  } else {
    throw new Error('Error occurred while processing your request')
  }
}
